import { create } from 'zustand'

/**
 * Form Specific Flags that can be used to provide additional feature
 * - CUSTOM_BRANCH: Manually control the bank branch that the form will be assigned to
 */
export type FormFlags =
  | 'CUSTOM_BRANCH'
  | 'FTS_OPS_PROCESS'
  | 'BDA_NAME'
  | 'WORKFLOW_TYPE'

/**
 * Global Form State that will be provided with all form client segments
 * - Form Flags: Form Sepcfic Custom Flags used to provide additional features, eg: Custom Branch
 *
 */
export interface FormState {
  formFlags?: Partial<Record<FormFlags, unknown>>
  setFlag: (flag: FormFlags, flagValue: unknown) => void
  unsetFlag: (flag: FormFlags) => void
  reset: () => void
}
// TO-DO: Pass other client specific details like useForm
const useFormStore = create<FormState>()((set) => ({
  formFlags: undefined,
  setFlag: (flag, flagValue) =>
    set((state) => ({
      formFlags: {
        ...state.formFlags,
        [flag]: flagValue,
      },
    })),
  unsetFlag: (flag) => {
    set((state) => {
      if (state.formFlags?.[flag]) {
        delete state.formFlags[flag]
      }
      return { formFlags: state.formFlags }
    })
  },
  reset: () => set({ formFlags: undefined }),
}))

export default useFormStore
